<template lang="html">
  <div class="chargingtips">
    <div class="tips-conetnt">
      <h4 class="title">关于调整BitaHub收费标准的通知</h4>
      <div class="conetnt">
        <p>各位用户：</p>
        <p class="para">你们好！</p>
        <p class="para">自2018年6月发布以来，BitaHub已试运行15个月。期间，在大家的陪伴和支持下，我们不断完善平台功能和使用体验，平台的使用量与活跃度亦不断提升。</p>
        <p class="para">为支撑后续发展、向用户提供更有价值的服务，BitaHub将于2019月10月10日起结束试运行、启动正式运行，相关计算资源的收费标准同步调整如下：</p>
        <img class="charging-image1" src="../../common/image/chargimg/charging-image1.jpg">
        <div class="poin">（更多内容，详见 <a href="https://bitahub.ustc.edu.cn/landingprice" target="_blank" >https://bitahub.ustc.edu.cn/landingprice</a> ）</div>
        <p>平台现已开通银联、微信支付通道，用户可进行算力在线充值：</p>
        <img class="charging-image2" src="../../common/image/chargimg/charging-image2.jpg">
        <img class="charging-image2" src="../../common/image/chargimg/charging-image3.jpg">
        <br>
        <p>团队/企业合作，欢迎垂询：</p>
        <p>【联系电话】0551-65708115</p>
        <p>【电子邮箱】<a href="mailto:bitahub@leinao.ai">bitahub@leinao.ai</a> </p>
        <br>
        <p>如有更多提问，欢迎与我们联系：</p>
        <p>【联系电话】18156023697</p>
        <p>【电子邮箱】<a href="mailto:survey1@leinao.ai">survey1@leinao.ai</a></p>
        <p>【客服微信】leinao1</p>
        <br>
        <p>感谢一路陪伴，期待更多未来！</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'chargingtips'
}
</script>

<style lang="stylus">
.chargingtips
  max-width 1100px
  margin 0 auto
  padding 30px 0
  .tips-conetnt
    padding 40px 60px
    border 1px solid #d2d2d2
    border-radius 8px
    .title
      line-height 24px
      padding-bottom 36px
      text-align center
      font-size 18px
      color #333
      font-weight 600
    .conetnt
      line-height 30px
      font-size 14px
      color #333
      .para
        text-indent 1em
      .charging-image1
        display block
        padding 12px 0
        width 80%
        margin 0 auto
      .charging-image2
        display block
        padding 12px 0
        width 60%
        margin 0 auto
      .poin
        color #666
        text-align center
        padding-bottom 20px
</style>
